import { BellaClientStorageDriver, clientStorageDrivers } from '../types';
import getLocalStorageDriver from './localStorage';

const storageDrivers = {
    [clientStorageDrivers.localStorage]: getLocalStorageDriver,
};

const getDriver = (key?: clientStorageDrivers): BellaClientStorageDriver => {
    const createDriver =
        key && storageDrivers[key] ? storageDrivers[key] : storageDrivers[clientStorageDrivers.localStorage];

    return createDriver();
};

export default getDriver;
